module.exports = __webpack_public_path__ + "media/img/frontend_application/venue/catering-icon-4f5ea60deb5142126e6dff40b1aeefc4.png";